import * as React from 'react'

const Loader = ({
	size = 16,
	color = '#001689',
	strokeWidth = 2,
	...props
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		{...props}
	>

		<path
			d="M8 12V14.6667"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M10.8267 10.8267L12.7133 12.7133"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M3.28662 12.7133L5.17329 10.8267"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M12 8H14.6667"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M1.33337 8H4.00004"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M10.8267 5.17335L12.7133 3.28668"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M3.28662 3.28668L5.17329 5.17335"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

		<path
			d="M8 1.33331V3.99998"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>

	</svg>
)

export default Loader